export const OFFLINE_TIME_MAX_MS = 1000 * 60 * 15; // 15 minutes
export const DAY_MS = 1000 * 60 * 60 * 24; // 24 hours
export const DAY_IN_SECONDS = 60 * 60 * 24; // 24 hours
export const HOUR_MS = 1000 * 60 * 60; // 1 hour
export const MINUTE_MS = 1000 * 60; // 1 minute
